module.exports = __webpack_public_path__ + "img/perplexity-ico.6551acf8.svg";